import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import countryList from "country-list";
import { useFormikContext } from "formik";
import { getFlagUrl } from "../client/utils";

export type Country = {
  code: string;
  name: string;
};

interface AddClientFormValues {
  "client-name": string;
  "address-street": string;
  "address-zip-code": string;
  "address-city": string;
  "country-select": Country;
  "main-user-first-name": string;
  "main-user-last-name": string;
  email: string;
}

export default function SingleCountrySelect() {
  const [inputValue, setInputValue] = React.useState<string>("");

  const context = useFormikContext<AddClientFormValues>();

  return (
    <Autocomplete
      value={context.values["country-select"]}
      inputValue={inputValue}
      onChange={(_, value) => {
        context.setFieldValue("country-select", value ? value : null);
      }}
      onInputChange={(_, countryName) => setInputValue(countryName)}
      data-testid="country-selector"
      sx={{ minWidth: "48%" }}
      options={countryList.getData()}
      getOptionLabel={(country) => (country.name ? country.name : "")}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          <img
            loading="lazy"
            width="20"
            src={getFlagUrl(option.code)}
            srcSet={`${getFlagUrl(option.code)} 2x`}
            alt=""
          />
          {option.name}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Country"
          error={
            context.touched["country-select"] &&
            Boolean(context.errors["country-select"])
          }
          helperText={
            context.touched["country-select"] &&
            (context.errors["country-select"] as string)
          }
          slotProps={{
            htmlInput: { ...params.inputProps, autoComplete: "disable" },
          }}
        />
      )}
    />
  );
}
